import initLayoutContainer from 'opentok-layout-js';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ChevronLeftLarge, ChevronRightLarge } from 'wix-ui-icons-common';
import { DH } from '../../../../data-hooks';
import { useGridLayout } from '../../../../hooks/grid-layout';
import { IconButton } from '../../../commons/icon-button';
import { useVideoConfig } from '../../video-config-provider';
import { Tile } from '../tile';
import s from './grid-layout.scss';
const ratios = [9 / 16, 10 / 16, 4 / 3, 1, 2, 3 / 2];
export const GridLayout = ({ width, height }) => {
    const { mobile, webinar, sidePanelOpened } = useVideoConfig();
    const minRatio = ratios[0];
    const maxRatio = mobile ? ratios[5] : ratios[0];
    const [currentPage, setCurrentPage] = useState(0);
    const { attendees, visibleAttendeeIds, pagesCount, focusedAttendeeId } = useGridLayout(currentPage);
    const content = useRef(null);
    const landscape = window.innerWidth > window.innerHeight;
    const layout = useMemo(() => {
        if (!content.current) {
            return null;
        }
        return initLayoutContainer(content.current, {
            maxRatio,
            minRatio,
            fixedRatio: false,
            alignItems: 'center',
            ignoreClass: 'lv_ignored',
        }).layout;
    }, [content.current, visibleAttendeeIds]);
    useEffect(() => {
        layout && layout();
    }, [width, height, attendees, layout]);
    const setPreviousPage = () => (currentPage === 0 ? setCurrentPage(pagesCount - 1) : setCurrentPage(currentPage - 1));
    const setNextPage = () => (currentPage + 1 === pagesCount ? setCurrentPage(0) : setCurrentPage(currentPage + 1));
    return (React.createElement("div", { className: classNames(s.container, {
            [s.mobile]: mobile,
            [s.sidePanelOpened]: sidePanelOpened,
            [s.landscape]: landscape,
        }) },
        React.createElement("div", { className: s.content, ref: content },
            pagesCount > 1 ? (React.createElement("div", { className: "lv_ignored" },
                React.createElement(IconButton, { dataHook: DH.PREV_PAGE, className: classNames(s.button, s.buttonLeft), Icon: ChevronLeftLarge, onClick: setPreviousPage }),
                React.createElement(IconButton, { dataHook: DH.NEXT_PAGE, className: classNames(s.button, s.buttonRight), Icon: ChevronRightLarge, onClick: setNextPage }))) : null,
            attendees.map(attendeeId => {
                const visible = visibleAttendeeIds.includes(attendeeId);
                if (!visible) {
                    return null;
                }
                return (React.createElement("div", { className: s.tile, key: attendeeId },
                    React.createElement(Tile, { className: classNames({ [s.active]: !webinar && attendeeId === focusedAttendeeId }), attendeeId: attendeeId })));
            }))));
};
//# sourceMappingURL=grid-layout.js.map